import { Component, inject, OnInit } from '@angular/core';
import { EnvService } from '../env.service';
import { SharedSignalsService } from '../common/services/shared-signals.service';

@Component({
  selector: 'taly-app-redirect',
  templateUrl: './app-redirect.component.html',
  styleUrl: './app-redirect.component.scss',
  standalone: false,
})
export class AppRedirectComponent implements OnInit {
  transferSignal = inject(SharedSignalsService);
  envService = inject(EnvService);
  appLink: any;

  ngOnInit() {
    const osInfo = this.transferSignal?.userAgentType();
    const appLink = osInfo === 'iOS' ? this.envService.appIOSURL : this.envService.appAndroidURL;
    if (appLink) {
      window.location.href = appLink;
    }
  }
}
